/* eslint-disable */
// 1.Dependency
import { createStore } from "vuex";
import { getUserInfo, getUserCommonStat } from "@/service/account";
import { getMyFeedbackStatus } from "@/service/feedback";
import { addCartGoods, getCartGoods, updateCartGoods, deleteCartGoods } from "@/service/cart";
import { apps } from "@/assets/data/config/app";
import User from "@2kog/pkg-common/utils/user";
import router from "@/router";

// 2.Store
const store = {
    state: {
        user: {},

        navExpanded: true,

        app: "2kog",

        lang: User.getLocale() || "en-US",

        feedbackDot: false,

        carts: [],

        commonStat: {}, // 用户全局统计
    },
    mutations: {
        SET_USER(state, user) {
            state.user = user;
        },
        SET_NAV(state, val) {
            state.navExpanded = val;

            localStorage.setItem("nav_expanded", state.navExpanded);
        },
        SET_APP(state, val) {
            state.app = val;
        },
        SET_LOCALE(state, val) {
            state.lang = val;
        },
        SET_FEEDBACK_DOT(state, val) {
            state.feedbackDot = val;
        },
        SET_CARTS(state, val) {
            state.carts = val;
        },
        SET_COMMON_STAT(state, val) {
            state.commonStat = val;
        },
    },
    getters: {
        user: (state) => state.user,
        appLabel: (state) => {
            const app = apps.find((item) => item.value === state.app);
            return app ? app.label : "";
        },
        app: (state) => state.app,
        feedbackDot: (state) => state.feedbackDot,
        carts: (state) => state.carts,
        commonStat: (state) => state.commonStat,
    },
    actions: {
        async getProfile({ commit }) {
            return getUserInfo()
                .then((res) => {
                    commit("SET_USER", res.data.data);
                    User._save(res.data.data);
                    return res.data.data;
                })
                .catch((err) => {
                    console.error("获取用户信息失败", err);
                    if (err.data.code == -2) {
                        User.logout();
                        router.push({ name: "account-login", query: { redirect: router.currentRoute.value.fullPath } });
                    }
                    return Promise.reject(err);
                });
        },
        async loadFeedbackStatus({ commit }) {
            const res = await getMyFeedbackStatus();
            const { process_tiktok, follow_tiktok } = res.data?.data || {};
            // follow_tiktok小于process_tiktok,则显示红点
            const bol = ~~follow_tiktok < ~~process_tiktok;
            commit("SET_FEEDBACK_DOT", bol);
        },
        async addCart({ commit }, data) {
            const res = await addCartGoods(data);
            return res;
        },
        async loadCart({ commit }) {
            const res = await getCartGoods();
            commit("SET_CARTS", res.data.data || []);
            return res;
        },
        async updateCart({ commit }, data) {
            const res = await updateCartGoods(data);
            return res;
        },
        async deleteCart({ commit }, data) {
            const res = await deleteCartGoods(data);
            return res;
        },
        async loadCommonStat({ commit }) {
            const res = await getUserCommonStat();
            commit("SET_COMMON_STAT", res.data?.data || {});
            return res;
        },
    },
};

export default createStore(store);
